import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactBootstrapSlider from 'react-bootstrap-slider';

export default class Slider extends Component {
  constructor(props) {
    super(props);

    this.state = {
      range: this.props.range,
    };
  }

  handleChange = (event) => {
    this.setState({
      range: event.target.value,
    });
  };

  render() {
    const { title, getRange, slideStop, ...rest } = this.props,
      { range } = this.state,
      rangeDescription = getRange && getRange(this.state.range);

    return (
      <div className="sliderRangeWrapper">
        <div className="sliderRangeWrapper__row">
          <div className="title">{title}</div>
          <div className="sliderRange__value">
            <span className="from">
              {rangeDescription.from}
            </span>
            &nbsp;—&nbsp;
            <span className="to">
              {rangeDescription.to}
            </span>
          </div>
        </div>
        <ReactBootstrapSlider
          step={1}
          change={this.handleChange}
          slideStop={slideStop}
          value={range}
          {...rest}
        />
      </div>
    );
  }
}

Slider.propTypes = {
  title: PropTypes.string,
  getRange: PropTypes.func,
  range: PropTypes.array,
  slideStop: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/RidesSidebar/Slider/index.js